"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoCamera = void 0;
var _jsxRuntime = require("react/jsx-runtime");
const VideoCamera = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
      opacity: "0.2",
      x: "5.5",
      y: "2.5",
      width: "9.8",
      height: "5.3",
      rx: "1.5",
      fill: "white",
      stroke: "#5750FA"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
      x: "3.5",
      y: "4.5",
      width: "13.4",
      height: "7.1",
      rx: "1.5",
      fill: "white",
      stroke: "#ABA7FD"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
      x: "1.5",
      y: "6.5",
      width: "17",
      height: "11",
      rx: "1.5",
      fill: "white",
      stroke: "#0A00FF"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M12.7596 11.5681C13.0904 11.761 13.0904 12.239 12.7596 12.4319L9.10908 14.5614C8.77575 14.7558 8.35714 14.5154 8.35714 14.1295L8.35714 9.87052C8.35714 9.48462 8.77575 9.24419 9.10908 9.43863L12.7596 11.5681Z",
      fill: "#0A00FF"
    })]
  });
};
exports.VideoCamera = VideoCamera;